// Header Search Icon
export function headerSearchIcon() {

  const searchIconDesktop = document.querySelector(".main-menu__icon--search");
  const searchButton = document.querySelector(".main-menu__button--search");
  const closeButton = document.createElement("button");
  closeButton.classList.add("search-close-button", "fas", "fa-times");
  
  const searchBar = document.querySelector(".main-menu__search-bar");
  searchBar.appendChild(closeButton);

  searchIconDesktop.addEventListener("click", function() {
      const siteLogo = document.querySelector(".wp-block-site-logo");
      const desktopNavLinks = document.querySelector(".main-menu__desktop-links");
      const storeIconDesktop = document.querySelector(".main-menu__icon--store");
      const menu = document.querySelector('.main-menu');

      siteLogo.style.display = "none";
      desktopNavLinks.style.display = "none";
      storeIconDesktop.style.display = "none";
      searchIconDesktop.style.display = "none";
      menu.classList.add('active');

      let sibling = searchBar.previousElementSibling;
      while (sibling) {
          sibling.style.display = 'none';
          sibling = sibling.previousElementSibling;
      }

      sibling = searchBar.nextElementSibling;
      while (sibling) {
          sibling.style.display = 'none';
          sibling = sibling.nextElementSibling;
      }

      searchBar.style.display = 'flex';
      closeButton.style.display = 'block';
  });

  const overlay = document.createElement('div');
  overlay.className = 'main-menu__search-mobile-overlay';
  
  document.body.appendChild(overlay);

  searchButton.addEventListener("click", function() {
    var existingIcon = document.querySelector('.main-menu__search-bar .fas.fa-search');
    if (!existingIcon) {
        var searchIcon = document.createElement("i");
        searchIcon.classList.add("fas", "fa-search", "mobile-search-icon");

        searchIcon.addEventListener('click', function() {
            var searchButton = document.querySelector('.wp-block-search__button');
            if (searchButton) {
                searchButton.click();
            }
        });
    }

    overlay.style.display = 'flex';
    overlay.appendChild(searchBar);
    overlay.appendChild(closeButton);

    searchBar.style.zIndex = '100002';
    searchBar.style.display = 'block';

    if (!existingIcon) {
        var insideWrapper = searchBar.querySelector('.wp-block-search__inside-wrapper');
        var searchInput = searchBar.querySelector('.wp-block-search__input');
        if (insideWrapper && searchInput) {
            insideWrapper.insertBefore(searchIcon, searchInput);
        }
    }
});



  closeButton.addEventListener('click', function(e) {
    e.preventDefault();
      if (overlay.contains(searchBar)) {
          overlay.style.display = 'none';
      } else {
          const elementsToShow = [".wp-block-site-logo", ".main-menu__desktop-links", ".main-menu__icon--store", ".main-menu__icon--search"];
          const menu = document.querySelector('.main-menu');

          elementsToShow.forEach(selector => {
              const elements = document.querySelectorAll(selector);
              elements.forEach(element => {
                  element.style.display = ''; 
              });
          });

          let sibling = searchBar.previousElementSibling;
          while (sibling) {
              sibling.style.display = '';
              sibling = sibling.previousElementSibling;
          }

          sibling = searchBar.nextElementSibling;
          while (sibling) {
              sibling.style.display = '';
              sibling = sibling.nextElementSibling;
          }

          searchBar.style.display = 'none';
          menu.classList.remove('active');
      }
  });
}
